<script setup lang="ts">
import usePmsiStayListTable from '@/stay-list/stay-list-table/composables/pmsiStayListTable'
import { ListSmrStay } from '@/stay-list/stay-list-table/smr/types'
import { PmsiTypeEnum } from '@/store/modules/settings/types'

const PmsiStayListTable = usePmsiStayListTable<ListSmrStay>(PmsiTypeEnum.SMR)
</script>

<template>
  <component :is="PmsiStayListTable" />
</template>